import React, { useEffect, useState, useRef } from 'react';
import styles from './Home.module.css'; // CSS module for Home component
import Section from "./Section";
import { useNavigate } from 'react-router-dom';

const BASE_URL = process.env.REACT_APP_IMAGE_BASE_URL;
const bgWork = `${BASE_URL}/bg-work.JPG`;
const bgAbout = `${BASE_URL}/bg-about.JPG`;

const Home: React.FC = () => {
    const navigate = useNavigate();
    const sections = [
        { title: 'WORK', backgroundImage: bgWork, buttonText: 'ENTER' },
        { title: 'ABOUT', backgroundImage: bgAbout, buttonText: 'LEARN' },
        // Add other sections as needed
    ];
    const [showArrow, setShowArrow] = useState(true);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleScroll = () => {
            if (!containerRef.current) return;
            const scrollTop = containerRef.current.scrollTop;
            const sectionHeight = containerRef.current.offsetHeight;
            // Hide arrow if scrolled past the first section
            setShowArrow(scrollTop < sectionHeight / 2);
        };
        const container = containerRef.current;
        if (container) {
            container.addEventListener('scroll', handleScroll);
        }
        return () => {
            if (container) {
                container.removeEventListener('scroll', handleScroll);
            }
        };
    }, []);

    return (
        <>
            <div ref={containerRef} className={`${styles.homeContainer} ${styles.snapScroll}`}>
                {sections.map((section, index) => (
                    <Section
                        key={index}
                        {...section}
                        styles={styles}
                        className={styles.section}
                        onButtonClick={
                          section.title === 'WORK'
                            ? () => navigate('/work')
                            : section.title === 'ABOUT'
                              ? () => navigate('/about')
                              : undefined
                        }
                    />
                ))}
            </div>
            {showArrow && (
                <div className={styles.arrowDown} onClick={() => {
                  if (containerRef.current) {
                    const sections = containerRef.current.querySelectorAll('.' + styles.section);
                    if (sections.length > 1) {
                      (sections[1] as HTMLElement).scrollIntoView({ behavior: 'smooth' });
                    }
                  }
                }}>
                  <svg width="32" height="32" viewBox="0 0 32 32">
                    <polyline points="8,12 16,20 24,12" fill="none" stroke="white" strokeWidth="4" strokeLinecap="round" />
                  </svg>
                </div>
            )}
        </>
    );
};

export default Home;
